import "./App.scss";
import React from "react";
import Card from "./pages/Card";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <BrowserRouter>
      <Card />
      <ToastContainer />
    </BrowserRouter>
  );
}

export default App;
